import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "../api/axios";

const RestablecerClave = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => searchParams.get("token") || "", [searchParams]);

  const [nuevaClave, setNuevaClave] = useState("");
  const [confirmarClave, setConfirmarClave] = useState("");
  const [mostrarClave, setMostrarClave] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validando, setValidando] = useState(true);
  const [tokenValido, setTokenValido] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const validar = async () => {
      if (!token) {
        setError("El enlace de recuperacion es invalido o esta incompleto.");
        setValidando(false);
        return;
      }

      try {
        await api.get(`/usuarios/restablecer-clave/validar?token=${encodeURIComponent(token)}`);
        setTokenValido(true);
      } catch (err) {
        console.error("Error al validar token de recuperacion:", err?.response?.data || err.message);
        setError(err.response?.data?.error || "El enlace de recuperacion es invalido o vencio.");
      } finally {
        setValidando(false);
      }
    };

    validar();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setMensaje("");
    setError("");

    if (nuevaClave !== confirmarClave) {
      setError("Las claves no coinciden.");
      return;
    }

    if (nuevaClave.length < 6) {
      setError("La nueva clave debe tener al menos 6 caracteres.");
      return;
    }

    setLoading(true);

    try {
      const { data } = await api.post("/usuarios/restablecer-clave", {
        token,
        nuevaClave
      });
      setMensaje(data?.mensaje || "Clave restablecida correctamente.");
      setTimeout(() => navigate("/"), 1800);
    } catch (err) {
      console.error("Error al restablecer clave:", err?.response?.data || err.message);
      setError(err.response?.data?.error || "No se pudo restablecer la clave.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <p className="auth-card__eyebrow">Recuperacion de acceso</p>
        <h2 className="auth-card__title">Restablecer clave</h2>
        <p className="auth-card__subtitle">
          Define una nueva contrasena para volver a ingresar al sistema.
        </p>

        {validando ? (
          <div className="alert alert-warning">Validando enlace de recuperacion...</div>
        ) : (
          <>
            {mensaje && <div className="alert alert-success">{mensaje}</div>}
            {error && <div className="alert alert-danger">{error}</div>}

            {tokenValido && (
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Nueva clave</label>
                  <div className="input-group">
                    <input
                      type={mostrarClave ? "text" : "password"}
                      className="form-control"
                      value={nuevaClave}
                      onChange={(e) => setNuevaClave(e.target.value)}
                      required
                      autoComplete="new-password"
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setMostrarClave((prev) => !prev)}
                      aria-label={mostrarClave ? "Ocultar clave" : "Mostrar clave"}
                    >
                      {mostrarClave ? "Ocultar" : "Mostrar"}
                    </button>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Confirmar clave</label>
                  <input
                    type={mostrarClave ? "text" : "password"}
                    className="form-control"
                    value={confirmarClave}
                    onChange={(e) => setConfirmarClave(e.target.value)}
                    required
                    autoComplete="new-password"
                  />
                </div>

                <button type="submit" className="btn btn-primary w-100 mt-2" disabled={loading}>
                  {loading ? "Actualizando..." : "Guardar nueva clave"}
                </button>
              </form>
            )}
          </>
        )}

        <div className="mt-3 text-center">
          <Link to="/">Volver al login</Link>
        </div>
      </div>
    </div>
  );
};

export default RestablecerClave;
